import { usePlatformData } from "@/hooks/platform/use-platform-data";
import { Loader2 } from "lucide-react";

export function AuthLayout({ children }) {
  const { data: platform, isLoading } = usePlatformData();

  if (isLoading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin" />
      </div>
    );
  }

  return (
    <div className="flex min-h-full flex-1 bg-white">
      <div className="flex flex-col lg:w-1/2 w-full justify-between px-4 py-12 sm:px-6 lg:flex-none lg:px-14">
        <div>
          <img
            className="h-7 w-auto"
            src={`https://cdn.pocketbook.tech/${platform?.commercial_logo_full}`}
            alt="Logo full"
          />
        </div>
        {children}
        <div className="flex flex-col">
          <p className="mt-2 text-sm leading-6 text-gray-500">
            Questions? Feel free to{" "}
            <a
              href="mailto:support@pocketbook.tech"
              className="inline-flex items-center justify-center text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50  text-slate-800 underline-offset-4 hover:underline "
            >
              contact our team.
            </a>
          </p>
        </div>
      </div>
      <div className="relative hidden w-1/2 lg:flex bg-skin-primary justify-center items-center">
        <img
          className="w-full max-w-[240px] lg:max-w-[340px] h-auto"
          src={`https://cdn.pocketbook.tech/${platform?.commercial_logo}`}
          alt="Logo"
        />
      </div>
    </div>
  );
}
